import React from "react";
import "./underConstruction.css";
import { useParams } from 'react-router-dom';
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";

function UnderConstruction() {

    const params = useParams();
    
    return (
        <Page>
            <Header />
            <section className="container">
                {params.id === "1" && (
                    <h3 className="subject m-5">باشگاه مشتریان</h3>
                )}
                {params.id === "2" && (
                    <h3 className="subject m-5">گواهینامه های آموزشی</h3>
                )}
                {params.id === "3" && (
                    <h3 className="subject m-5">نقشه انفجاری</h3>
                )}
                <h3 className="subject m-5">در حال پیاده سازی</h3>
                <img className="img-fluid centerimg" src={require('../../assets/images/general/UnderConstruction.jpg')} alt="" />
            </section>
            <Footer />
        </Page>
    );
}

export default UnderConstruction;
